export default __webpack_public_path__ + "static/media/promocode_mobile_Hk.ca7516c5.webp";